import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, Package, Mail, Settings } from 'lucide-react';

const MobileBottomNav = () => {
  const location = useLocation();

  const navItems = [
    { name: 'Ana səhifə', path: '/', icon: Home },
    { name: 'Çantalar', path: '/bags', icon: ShoppingBag },
    { name: 'Məhsullar', path: '/products', icon: Package },
    { name: 'Əlaqə', path: '/contact', icon: Mail },
    // { name: 'Admin', path: '/admin', icon: Settings },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      className="mobile-bottom-nav fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-brand-secondary/30 z-50 md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.05)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center py-1 px-3 rounded-xl transition-all duration-300 ${
                active 
                  ? 'text-brand-primary bg-brand-accent/30' 
                  : 'text-brand-muted hover:text-brand-primary'
              }`}
              data-testid={`mobile-nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5px]' : ''}`} />
              <span className="text-[10px] mt-0.5 font-medium">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
